(function($, undefined) {
	'use strict';
	var utils;
	var cartUtils;

	var init = function() {
		utils = Fw.component.models().utils;
		cartUtils = Fw.component.models().cartUtils;

		$('.scroll-to-anchor-btn').on('click', onScrollToAnchorBtnClick);
	};

	function onScrollToAnchorBtnClick() {
		var btn = $(this);
		var anchorId = btn.attr("data-id");
		var anchorInPage = $('a[id=' + anchorId + ']').first();

		if (anchorInPage.length) {
			var offset = 20;
			if ($(window).scrollTop() >= anchorInPage.offset().top) {
				offset += $('.site-header').outerHeight();
			}
			utils.scrollToElement(anchorInPage, 300, offset);
		}
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
